// @ts-strict-ignore
import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {DownloadMode} from 'common/report/constants';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {getLocation} from 'common/util/url';

import {FormattedReportMeta, ReportMeta} from './types';
import {template} from './template';
import css from './index.inline.styl';

const DOWNLOAD_DATE_FORMAT = `MMM D, YYYY`;

export type DownloadWrapperAttrs = {
  meta: ReportMeta;
  mode: DownloadMode;
};

export type DownloadWrapperProps = {
  attrs?: DownloadWrapperAttrs;
};
export class DownloadWrapper extends Component<EmptyObj, DownloadWrapperAttrs> {
  static get attrsSchema(): AttrsSchema<DownloadWrapperAttrs> {
    return {
      ...super.attrsSchema,
      meta: {type: `json`, description: `interface: ReportMeta`},
      mode: {type: `number`, description: `enum: DownloadMode`, default: 0},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        getFormattedReportMeta: () => this.getFormattedReportMeta(),
        getReportLocation: () => this.getReportLocation(),
        isFileDownload: () => this.attr(`mode`) === DownloadMode.File,
      },
    };
  }

  // Used by slack app, change carefully
  public getFormattedReportMeta(): FormattedReportMeta {
    const {title, dateRange, subtitles, reportName, analysisType, isEmpty, hasUnsavedChanges, bookmarkType} =
      this.getJSONAttribute(`meta`) as ReportMeta;
    const {from, to} = new DateRange(dateRange).getCalendarDates(DOWNLOAD_DATE_FORMAT);
    const reportTypeSubtitle = analysisType ? `${reportName}, ${analysisType}` : reportName;

    return {
      title,
      isEmpty,
      fromDate: from,
      toDate: to,
      subtitles: [reportTypeSubtitle, ...subtitles],
      hasUnsavedChanges,
      bookmarkType,
    };
  }

  // Screenshot host in puppeteer is web-internal, so we need to reconstruct the link
  private getReportLocation() {
    const url = new URL(getLocation().toString());
    url.host = url.searchParams.get(`request_origin`) || `mixpanel.com`;
    url.searchParams.delete(`download`);
    url.pathname = url.pathname.replace(/\/embed\/?$/, ``);
    url.protocol = `https:`;
    return url.href;
  }
}

export const DownloadWrapperEl = defineAndMakeJsxFactory<DownloadWrapperProps>(`mp-download-wrapper`, DownloadWrapper);
export const DownloadWrapperReact = panel2react<DownloadWrapperProps>(`mp-download-wrapper`, DownloadWrapper);
